"use client";

import { ColumnDef } from "@tanstack/react-table";
import { Button } from "../../../../components/ui/button";
import { ChevronUp, ChevronDown, ChevronsUpDown } from "lucide-react";
import moment from "moment";

export type Attribute = {
    data: string;
    timestamp: string;
};

export const columns: ColumnDef<Attribute>[] = [
    {
        header: "Value",
        accessorKey: "value",
    },
    {
        accessorKey: "timestamp",
        cell: (value) => {
            const date = parseInt(value.getValue() as string);
            return moment(date).format("DD/MM/YYYY h:mm:ss.SSS A");
        },
        header: ({ column }) => {
            return (
                <Button
                    variant="ghost"
                    onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                >
                    Timestamp
                    {column.getIsSorted() === "asc" ? (
                        <ChevronUp className="ml-2 h-4 w-4" />
                    ) : column.getIsSorted() === "desc" ? (
                        <ChevronDown className="ml-2 h-4 w-4" />
                    ) : (
                        <ChevronsUpDown className="ml-2 h-4 w-4" />
                    )}
                </Button>
            );
        },
    },
];
